import { formAPI } from 'api/form';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';

export function useDeleteForm() {
  const mutation = useMutation({
    mutationFn: formAPI.delete,
    onSuccess: () => {
      toast(locales.deleteSuccess, { type: 'success' });
    },
  });

  return mutation;
}
